export const generalKey = 'product_ps_delta_delta_3_c';
export const whiteLocaleList = ['us', 'ca']; //白名单
export const productPageUrl = 'delta-3-classic-portable-power-station';
export const tabsValues = ['Product', 'Specs', 'Bundles'];
export const productPageTheme = 'white'; //主题色

export const generalKeys = [
    {
        key: 'product_ps_delta_delta_3_c',
        url: 'delta-3-classic-portable-power-station',
    },
];
